import { BaremeSummary } from "@/features/sponsorship/components/reglement/BaremeSummary";
import { SponsorshipTermsContent } from "@/features/sponsorship/components/reglement/SponsorshipTermsContent";
import { useSponsorshipTerms } from "@/features/sponsorship/hooks/useSponsorshipTerms";
import { deriveBareme } from "@/features/sponsorship/utils/deriveBareme";
import { ResponsiveDialog } from "@/shared/components/responsiveDialog";
import { P } from "@/shared/ui/typographies/paragraph";

type Props = {
  open: boolean
  onClose: () => void
};

// Le règlement et son barème proviennent exclusivement de la base (version
// publiée servie par l'API). Aucun texte n'est embarqué côté front : tant
// qu'aucune version n'est publiée, on affiche un état vide explicite plutôt
// qu'un contenu factice.
export const ReglementDialog = ({ open, onClose }: Props) => {
  const { term, isLoading } = useSponsorshipTerms({ enabled: open });

  return (
    <ResponsiveDialog
      open={open}
      onClose={onClose}
      title="Conditions générales — Programme Yeati Blue"
      size="2xl"
    >
      {term
        ? (
          <>
            <BaremeSummary bareme={deriveBareme(term)} />
            <SponsorshipTermsContent bodyHtml={term.body_html} />
          </>
        )
        : (
          <P className="text-gray-600 dark:text-gray-400">
            {isLoading
              ? "Chargement du règlement…"
              : "Le règlement n'est pas encore disponible."}
          </P>
        )}
    </ResponsiveDialog>
  );
};

ReglementDialog.displayName = "ReglementDialog";
